import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ComponentSync, LL_H_C, LL_V_L, ModuleFE_Dialog, TS_Checkbox, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { ConfigKey_FindingView_Cockpit, findingViewType_Parent } from '@app/advisor-ui-shared';
import { ICONS } from '@app/styles';
import { DropDown_ContextRule, ModuleFE_ContextRule, Q_SortableList } from '@app/hcs-frontend';
import { ConfigKeyFE_FindingView_Cockpit, ModuleFE_FindingView } from '../../../_entity.js';
import { filterDuplicates, sortArray } from '@nu-art/ts-common';
import './ConfigDialog_FindingView_Cockpit.scss';
import { DropDown_FindingView } from '../../../_entity/finding-view/ui-components.js';
export class ConfigDialog_FindingView_Cockpit extends ComponentSync {
    // ######################## Static ########################
    static show() {
        const model = {
            dialogKey: ConfigKey_FindingView_Cockpit,
            closeOverlayOnClick: () => true,
            content: _jsx(ConfigDialog_FindingView_Cockpit, {}),
        };
        ModuleFE_Dialog.show(model);
    }
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state.config ??= ConfigKeyFE_FindingView_Cockpit.get() ?? [];
        return state;
    }
    // ######################## Logic ########################
    closeDialog = () => {
        ModuleFE_Dialog.close();
    };
    onTestResultsOrderChange = async (ids) => {
        const config = { ...this.state.config };
        config.testResults = [...config.testResults]; //Shallow clone the test results prop
        sortArray(config.testResults, config => ids.indexOf(config.findingViewId));
        await ConfigKeyFE_FindingView_Cockpit.set(config);
        this.setState({ config });
    };
    testResult_Add = async (findingView) => {
        if (findingView.type === findingViewType_Parent)
            return;
        const config = { ...this.state.config };
        config.testResults = [...config.testResults];
        const existing = config.testResults.find(config => config.findingViewId === findingView._id);
        if (existing)
            return;
        const testResult = {
            findingViewId: findingView._id,
            onlyAbnormalResults: false,
        };
        config.testResults.push(testResult);
        await ConfigKeyFE_FindingView_Cockpit.set(config);
        this.setState({ config });
    };
    testResult_Remove = async (fvId) => {
        const config = { ...this.state.config };
        config.testResults = config.testResults.filter(testResult => testResult.findingViewId !== fvId);
        await ConfigKeyFE_FindingView_Cockpit.set(config);
        this.setState({ config });
    };
    testResult_ToggleAbnormal = async (fvId) => {
        const config = { ...this.state.config };
        config.testResults = [...config.testResults];
        const testResult = config.testResults.find(testResult => testResult.findingViewId === fvId);
        if (!testResult)
            return;
        testResult.onlyAbnormalResults = !testResult.onlyAbnormalResults;
        await ConfigKeyFE_FindingView_Cockpit.set(config);
        this.setState({ config });
    };
    contextRule_Add = async (cr) => {
        const config = { ...this.state.config };
        config.hpiContextRuleIds = filterDuplicates([...config.hpiContextRuleIds, cr._id]);
        await ConfigKeyFE_FindingView_Cockpit.set(config);
        this.setState({ config });
    };
    contextRule_Remove = async (crId) => {
        const config = { ...this.state.config };
        config.hpiContextRuleIds = config.hpiContextRuleIds.filter(id => id !== crId);
        await ConfigKeyFE_FindingView_Cockpit.set(config);
        this.setState({ config });
    };
    // ######################## Render ########################
    render() {
        return _jsxs(LL_V_L, { id: 'config-dialog__finding-view__cockpit', className: 'config-dialog', children: [this.render_Title(), this.render_Content()] });
    }
    render_Title = () => {
        return _jsxs(LL_H_C, { className: 'config-dialog__title', children: ["Editor - Finding View - Cockpit", _jsx(ICONS.x.component, { className: 'config-dialog__title-icon', onClick: this.closeDialog })] });
    };
    render_Content = () => {
        return _jsxs(LL_H_C, { className: 'config-dialog__content', children: [this.render_TestResults(), this.render_VitalsFindingView(), this.render_HPIContextRules()] });
    };
    // ######################## Render - Test Results ########################
    render_TestResults = () => {
        const testResults = this.state.config.testResults;
        const fvIds = testResults.map(i => i.findingViewId);
        return _jsxs(TS_PropRenderer.Vertical, { label: 'Test Results', children: [_jsx(Q_SortableList, { items: fvIds, onChange: this.onTestResultsOrderChange, itemRenderer: this.render_TestResult }), _jsx(DropDown_FindingView.selectable, { selected: undefined, canUnselect: false, queryFilter: fv => fv.type !== findingViewType_Parent && !fvIds.includes(fv._id), onSelected: this.testResult_Add })] });
    };
    render_TestResult = (fvId) => {
        const testResults = this.state.config.testResults;
        const config = testResults.find(config => config.findingViewId === fvId);
        if (!config)
            return;
        const fv = ModuleFE_FindingView.cache.unique(fvId);
        return _jsxs(_Fragment, { children: [_jsx(ICONS.x.component, { onClick: () => this.testResult_Remove(fvId) }), _jsx("div", { className: 'finding-view__cockpit-config__label', children: fv?.label ?? 'N/A' }), _jsx(TS_Checkbox, { checked: config.onlyAbnormalResults, onCheck: () => this.testResult_ToggleAbnormal(fvId), children: "Only Abnormal Results" })] });
    };
    // ######################## Render - Vitals FV ########################
    render_VitalsFindingView = () => {
        const config = this.state.config;
        return _jsx(TS_PropRenderer.Vertical, { label: 'Vitals Finding View', children: _jsx(DropDown_FindingView.selectable, { selected: config.vitalsFindingViewId, onSelected: async (fv) => {
                    const newConfig = { ...config };
                    newConfig.vitalsFindingViewId = fv._id;
                    await ConfigKeyFE_FindingView_Cockpit.set(config);
                    this.setState({ config });
                } }) });
    };
    // ######################## Render - HPI Context Rules ########################
    render_HPIContextRules = () => {
        const config = this.state.config;
        return _jsxs(TS_PropRenderer.Vertical, { label: 'HPI Context Rules', children: [_jsx(LL_V_L, { children: config.hpiContextRuleIds.map(crId => {
                        const cr = ModuleFE_ContextRule.cache.unique(crId);
                        return _jsxs(LL_H_C, { children: [_jsx(ICONS.x.component, { onClick: () => this.contextRule_Remove(crId) }), cr?.label] }, crId);
                    }) }), _jsx(DropDown_ContextRule.selectable, { selected: undefined, canUnselect: false, queryFilter: cr => !config.hpiContextRuleIds.includes(cr._id), onSelected: this.contextRule_Add })] });
    };
}
//# sourceMappingURL=ConfigDialog_FindingView_Cockpit.js.map